
export default {
    name: 'info-operation',
    components: {},
    props: {
        info_operation: Object
    },
    data () {
        return {

        }
    },

    computed: {

    },

    mounted () {
        if (this.has_two_currencies) {
            this.currency_info = this.$store.getters['info_currency']
        }
    },

    methods: {

    }
}


